import React, { Component } from 'react';
import { FormControl, FormControlLabel, FormGroup, Checkbox, FormHelperText } from 'material-ui';

class CheckBoxComponent extends Component {

    render() {
        const { error } = this.props;
        return (
            <FormControl component="fieldset" disabled={this.props.disabled} error={error && error !== "" ? true : false}>
                <p style={customStyles[this.props.classTitle]}>{this.props.label}</p>
                <FormGroup style={{textAlign:'left', ...customStyles[this.props.classForm]}} row>
                    {this.props.items.map((item) => {
                        return (
                            <FormControlLabel
                                style={customStyles[this.props.classChecked]}
                                key={`${this.props.id}_${item.value}`}
                                control={
                                    <Checkbox
                                        checked={this.props.values.indexOf("" + item.value) !== -1 ? true : false}
                                        onChange={this.props.setValue}
                                        value={item.value + ""}
                                        color="secondary"
                                        disabled={this.props.disabled}
                                    />
                                }
                                label={item.text}
                            />
                        );
                    })}
                </FormGroup>
                {error && error !== "" && <FormHelperText>{error}</FormHelperText>}
            </FormControl>
        );
    }
}

const customStyles = {
    iconBack: {
        fontSize: "1.15rem",
        marginRight: "0.5rem"
    },
    containerDate: {
        textAlign: "center"
    },
    gridQuestion: {
        paddingBottom: "2rem",
        textAlign: "center",
        display: "flex",
        alignItems: "center"
    },
    ageRangeInput: {
        maxWidth: "23%",
        paddingRight: "1rem"
    },
    formCard: {
        width: "100%",
        display: "flex",
        paddingTop: "1.2rem",
        marginBottom: "1.2rem",
        paddingLeft: "1rem"
    },
    gridAgeRange: {
        paddingBottom: "2rem",
        textAlign: "center"
    },
    customLabel: {
        margin: 0
    },
    formChecked: {
        width: "23%",
        paddingRight: "0.6em"
    },
    formReason: {
        display: "flex",
        justifyContent: "center"
    },
    iconSave: {
        fontSize: "1.3rem",
        paddingRight: "0.3rem"
    }
}


export default CheckBoxComponent;



// WEBPACK FOOTER //
// ./src/components/displayComponents/CheckBoxComponent.js